export const width = Math.floor(744 * 0.5);
export const height = Math.floor(496 * 0.5);
